// @ts-nocheck -- This file had typechecking errors that must be resolved by hand

const config = {
  production: {
    typeaheadServiceBaseUrl: '/typeahead/',
  },
  staging: {
    typeaheadServiceBaseUrl: '/typeahead/',
  },
  development: {
    typeaheadServiceBaseUrl: 'https://www.redbubble-staging.com/typeahead/',
  },
};

export default function get(key?: any) {
  const env = process.env.NODE_ENV;

  return Object.keys((config as any)[env] || {}).length
    ? (config as any)[env][key]
    : undefined;
}
